export default {
    dadosGerais:{},
    orgaos: {},
    defaultLoadingMessage: 'Carregando...',
    rota: {
        origem: 'Inicial'
    }
}
